import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { PRIMITIVE_COLORS } from '@/constants/residents/residentColors';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { GlassCard } from '../GlassCard';
import { Hoverable } from '@/components/shared/redesign/Hoverable';
import { strings } from '@/constants/residents';

interface FAQSupportCardProps {
  onSupportPress: () => void;
}

export const FAQSupportCard: React.FC<FAQSupportCardProps> = React.memo(({ onSupportPress }) => {
  const { colors } = useThemeColors();

  return (
    <GlassCard borderRadius={16}>
      <View style={styles.row}>
        <RESIDENTS_SVG_COMPONENTS.QUESTION_BUBBLE
          width={56}
          height={58}
          color={colors.text.muted}
        />
        <View style={styles.textCol}>
          <Text style={[styles.title, { color: colors.text.primary }]}>{strings.faqCard.cardTitle}</Text>
          <Text style={[styles.subtitle, { color: colors.text.dim }]}>{strings.faqCard.cardSubtitle}</Text>
          <Text style={[styles.subtitle, { color: colors.text.dim }]}>{strings.faqCard.cardSubtitle2}</Text>
          <Hoverable
            hover="button"
            accessibilityRole="button"
            onPress={onSupportPress}
            style={styles.ctaButton}
            testID="FAQ_GetInTouch"
          >
            <Text style={styles.ctaText}>{strings.faqCard.cardCta}</Text>
          </Hoverable>
        </View>
      </View>
    </GlassCard>
  );
});

FAQSupportCard.displayName = 'FAQSupportCard';

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 16,
  },
  textCol: {
    flex: 1,
    gap: 2,
  },
  title: {
    ...REDESIGN_TYPOGRAPHY.sectionTitle,
    marginBottom: 4,
  },
  subtitle: {
    ...REDESIGN_TYPOGRAPHY.body,
    lineHeight: 20,
  },
  ctaButton: {
    marginTop: 16,
    alignSelf: 'flex-start',
    backgroundColor: PRIMITIVE_COLORS.resioBlue,
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 10,
  },
  ctaText: {
    ...REDESIGN_TYPOGRAPHY.buttonSmall,
    color: '#FFFFFF',
  },
});
